import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 2c1.875.8 4 1.2 4 1.2l-.424 4.217a10 10 0 0 1-6.8 8.491L8 16l-.276-.092A10 10 0 0 1 .999 8a10.04 10.04 0 0 1-.075-.583L.5 3.2s2.125-.4 4-1.2C6.369 1.203 7.99.008 8 0c0 0 1.625 1.2 3.5 2ZM8 2.404c-.69.43-1.656.983-2.715 1.436a21.09 21.09 0 0 1-2.62.898l.249 2.479c.026.265.066.526.117.783H8v5.883A8 8 0 0 0 12.969 8H8V2.404Z",
    fill: "currentColor"
  }));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Security16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Security16 = createIcon(IconComponent);